initializeTestimonialTabs();

function initializeTestimonialTabs() {
  var testimonialsTabList = [].slice.call(
    document.querySelectorAll('.nav-testimonial-tabs [data-bs-toggle="tab"]')
  );

  testimonialsTabList.forEach(function (testimonialTab) {
    testimonialTab.addEventListener('shown.bs.tab', function (e) {
      if (e.target) {
        var tabPaneID = e.target.getAttribute('href');
        var tabPane = document.querySelector(tabPaneID);
        var tabVideo = tabPane.getElementsByTagName('video');
        if (tabVideo.length > 0) {
          tabVideo[0].play();
        }
      } else if (e.relatedTarget) {
        var tabPaneID = e.relatedTarget.getAttribute('href');
        var tabPane = document.querySelector(tabPaneID);
        var tabVideo = tabPane.getElementsByTagName('video');
        if (tabVideo.length > 0) {
          tabVideo[0].pause();
        }
      }
    });
  });
}

export { initializeTestimonialTabs };
